import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_DocOfHealthcareProviderVisits = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_DocOfHealthcareProviderVisits' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Documentation of Healthcare Provider Visits</h3></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name of Health Care Provider:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Type of Health Care Provider:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtHealthCare' name='txtHealthCare' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtHealthCare1' name='txtHealthCare1' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p>
                    <span className='eleHeader'>Reason for Visit:</span>
                    <textarea id='txtVisit' name='txtVisit' className='add-only'></textarea>
                </p>

                <p className='w-750'><h4>Outcomes/Results</h4></p>

                <p>
                    <span className='eleHeader'>Diagnosis(es) (if applicable)</span>
                    <textarea id='txtDiagnosis' name='txtDiagnosis' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Procedure(s) conducted</span>
                    <textarea id='txtProcedure' name='txtProcedure' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Procedure(s) ordered:</span>
                    <textarea id='txtProcedure1' name='txtProcedure1' className='add-only'></textarea>
                </p>
                <p>
                    Date: &nbsp;<input type='date' id='txtDate1' name='txtDate1' className='add-only w-200 custom-add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Describe any needed follow up, including dates:</span>
                    <textarea id='txtDescribe' name='txtDescribe' className='add-only'></textarea>
                </p>

                <p className='w-750'><h4>Source of Information</h4></p>

                <p>
                    <input type='checkbox' name='chkSource' id='chkSource' className='add-only' value='Provider' />Provider/ Staff participated in the visit
                </p>
                <p>
                    <input type='checkbox' name='chkSource1' id='chkSource1' className='add-only' value='Family' />Family/Guardian participated in the  visit and provided results of the visit to the program
                </p>
                <p>
                    <input type='checkbox' name='chkSource2' id='chkSource2' className='add-only' value='ProviderAccess' />Provider assisted with access to healthcare but did not participate in the visit
                </p>
                <p>
                    <input type='checkbox' name='chkSource3' id='chkSource3' className='add-only' value='ReleaseCompleted' />Release of records completed
                </p>
                <p>
                    <input type='checkbox' name='chkSource4' id='chkSource4' className='add-only' value='RecordsRequestedHealthcareProvider' />Records requested from healthcare provider
                </p>


            </div>
        </form >

    )
}











